import { AccountType } from "@common/constants/domains/accounting/accounts";
import { isAccountType } from "@common/constants/domains/accounting/helpers";
import { AccountGroup } from "@common/types/domains/accounting/account";

// Report-leaf folding is presentation-only; group selection requires a live exact type.
export const resolveSelectableGroupType = (
    type: string | null,
): AccountType | null => {
    if (!type || !isAccountType(type)) {
        return null;
    }
    return type;
};

export const filterGroupsBySelectableType = (
    groups: AccountGroup[],
    type: string | null,
): AccountGroup[] => {
    const selectedType = resolveSelectableGroupType(type);
    if (!selectedType) {
        return [];
    }
    return groups.filter((group) => group.type === selectedType);
};
